import { render } from "./PaginationDesign.vue?vue&type=template&id=6070a67c"
import script from "./PaginationDesign.vue?vue&type=script&lang=js"
export * from "./PaginationDesign.vue?vue&type=script&lang=js"

import "./PaginationDesign.vue?vue&type=style&index=0&id=6070a67c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__